export const getLocationRequestPayloadByAlternateVersion = (
  defaultRequestPayload: Record<string, Record<string, unknown>>,
  contactGroupId: number,
  isAlternateVersionEnabled: boolean
) => {
  if (!contactGroupId) {
    return defaultRequestPayload;
  }

  if (!isAlternateVersionEnabled) {
    return {
      ...defaultRequestPayload,
      filters: {
        ...defaultRequestPayload.filters,
        contactGroupId,
      },
    };
  }

  return {
    ...defaultRequestPayload,
    viewBy: {
      contactGroupId,
      includeOtherContactGroups: 1,
    },
  };
};
